import { fromPromise } from 'xstate5';

import { type ClaimOfferInput, type ClaimOfferResponse } from '../click-to-claim.machine.types';

// ─── External Actors ─────────────────────────────────────────────────────────

const claimOffer = fromPromise<ClaimOfferResponse, ClaimOfferInput>(async () => {
  throw new Error('Not implemented');
});

// ─────────────────────────────────────────────────────────────────────────────

export const Actors = {
  claimOffer,
};
